/* eslint-disable camelcase */
import Vue from 'vue'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required, confirmed, min, max, numeric, min_value, max_value } from 'vee-validate/dist/rules'

// Add a rule.
extend('email', {
  validate: (value) => {
    return value.match(
      /^([a-zA-Z0-9_-]+\.)*[a-zA-Z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,4}$/
    )
  },
  message: 'emailError'
})

extend('required', {
  ...required,
  message: 'required'
})

extend('confirmed', {
  ...confirmed,
  message: 'notEqualPasswords'
})

extend('min', {
  ...min,
  message: (value, args) => {
    return {
      message: 'minLength',
      value: args.length
    }
  }
})

extend('max', {
  ...max,
  message: (value, args) => {
    return {
      message: 'maxLength',
      value: args.length
    }
  }
})

extend('isUsername', {
  validate: (value) => {
    return value.match(/^[a-zA-Z0-9_]+$/)
  },
  message: 'isUsername'
})

extend('numeric', {
  ...numeric,
  message: 'numeric'
})

extend('min_value', {
  ...min_value,
  validate: (value, args) => {
    if (value >= args.min) return true
  },
  message: (value, args) => {
    return {
      message: 'minValue',
      value: args.min
    }
  }
})

extend('max_value', {
  ...max_value,
  validate: (value, args) => {
    if (value <= args.max) return true
  },
  message: (value, args) => {
    return {
      message: 'maxValue',
      value: args.max
    }
  }
})

// Register it globally
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)



// WEBPACK FOOTER //
// ./src/pkg/vee-validate/vee-validate.js